import { PaymentScheduleStage } from '@/ui/components/paymentScheduleStageCards/PaymentScheduleStage';
import {
  ProposalDepositStageCard,
  ProposalInstalmentStageCard,
} from '@/ui/components/paymentScheduleStageCards/ProposalPaymentScheduleStageCards';
import { toValuableStoredPaymentSchedule } from '@/ui/components/paymentScheduleStageCards/stageHelpers';
import { usePaymentScheduleStages } from '@/ui/components/paymentScheduleStageCards/usePaymentScheduleStages';
import { FieldError } from '@payaca/ambrosia';
import {
  getStoredStagesWithGrossValues,
  withExactFullAllocation,
} from '@payaca/helpers/paymentScheduleHelper';
import { FC } from 'react';

type Props = {
  /** Proposal total in minor units, inc tax. */
  proposalTotal: number;
};

const PaymentScheduleEditor: FC<Props> = (props) => {
  const { proposalTotal } = props;

  const {
    fields,
    stages,
    allocatedPercentage,
    remainingPercentage,
    addStage,
    removeStage,
    setFirstStageIsDeposit,
    stagesErrorMessage,
  } = usePaymentScheduleStages();

  const stageAmounts = getStoredStagesWithGrossValues(
    withExactFullAllocation(toValuableStoredPaymentSchedule(stages)),
    proposalTotal
  ).map(({ value }) => value ?? 0);

  if (!fields.length) {
    return <PaymentScheduleStage.AddScheduleButton onClick={addStage} />;
  }

  return (
    <div className="flex flex-col gap-4">
      <PaymentScheduleStage.Header allocatedPercentage={allocatedPercentage} />
      <div className="flex flex-col gap-4">
        {fields.map((field, index) => {
          const StageCard =
            stages[index]?.type === 'deposit'
              ? ProposalDepositStageCard
              : ProposalInstalmentStageCard;
          return (
            <StageCard
              key={field.id}
              index={index}
              proposalTotal={proposalTotal}
              amount={stageAmounts[index] ?? 0}
              remainingPercentage={remainingPercentage}
              onDepositChange={index === 0 ? setFirstStageIsDeposit : undefined}
              onRemove={() => removeStage(index)}
            />
          );
        })}
      </div>
      {stagesErrorMessage && <FieldError messages={[stagesErrorMessage]} />}
      <PaymentScheduleStage.AddStageButton
        remainingPercentage={remainingPercentage}
        onClick={addStage}
      />
      <PaymentScheduleStage.ExplainerField />
    </div>
  );
};

export default PaymentScheduleEditor;
